export const VENDORS = ["All Vendors", "PARAM PACKAGING PRIVATE LIMITED", "GIVAUDAN (INDIA) PVT LTD", "GANESH BENZOPLAST LTD.", "MISA FINECHEM PRIVATE LIMITED"];
export const SITES = ["All Sites", "Mumbai", "Pune", "Delhi", "Chennai", "Hyderabad"];
export const MATERIALS = ["All Materials", "Packaging Material", "Raw Chemical", "Flavour", "Solvent", "Pigment"];
export const EMAIL_INTENTS = ["Transporter", "Inventory", "Dispatch"];
export const UOM_OPTIONS = ["EA", "L", "M", "TO", "KG"];

export const VISIBLE_FILTER_LIMIT = 8;

export const STATUS_VALUE_LABELS = { pending: "Pending", validated: "Validated" };

export const ALL_FILTERS = [
  { key: "vendor", label: "Vendor Name", isFavourite: true },
  { key: "site", label: "Site", isFavourite: true },
  { key: "material", label: "Material Group", isFavourite: true },
  { key: "intent", label: "Email Intent", isFavourite: true },
  { key: "hitl_reason", label: "HITL Reason", multiValue: true, isFavourite: true },
  { key: "to", label: "To", multiValue: true, isFavourite: true },
  { key: "from", label: "From", multiValue: true, isFavourite: true },

];

export const EMPTY_SELECTED_FILTERS = ALL_FILTERS.reduce((acc, f) => ({ ...acc, [f.key]: [] }), {});

export const FILTER_BY_LABEL = ALL_FILTERS.reduce((acc, f) => ({ ...acc, [f.label]: f }), {});